import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/statistiques',
    component: ComponentCreator('/statistiques', '49c'),
    exact: true
  },
  {
    path: '/studio',
    component: ComponentCreator('/studio', 'ee7'),
    exact: true
  },
  {
    path: '/studio/:target*',
    component: ComponentCreator('/studio/:target*', '85b'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', 'fd7'),
    routes: [
      {
        path: '/docs/api/api-rest',
        component: ComponentCreator('/docs/api/api-rest', 'a23'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/api/core',
        component: ComponentCreator('/docs/api/core', 'f19'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/api/mécanismes',
        component: ComponentCreator('/docs/api/mécanismes', 'a5b'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/api/react-ui',
        component: ComponentCreator('/docs/api/react-ui', '558'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/guides/créer-formulaire',
        component: ComponentCreator('/docs/guides/créer-formulaire', 'd82'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/pourquoi-publicodes/introduction',
        component: ComponentCreator('/docs/pourquoi-publicodes/introduction', '1e1'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/pourquoi-publicodes/standard-modeles-ouverts',
        component: ComponentCreator('/docs/pourquoi-publicodes/standard-modeles-ouverts', 'aa8'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/principes-de-base',
        component: ComponentCreator('/docs/principes-de-base', '7bb'),
        exact: true,
        sidebar: "tutorialSidebar"
      },
      {
        path: '/docs/tutoriel',
        component: ComponentCreator('/docs/tutoriel', '25e'),
        exact: true,
        sidebar: "tutorialSidebar"
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'c9f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
